<template>
    <div v-if="eventData.privacyUrl || eventData.termsUrl || eventData.preContractualInfoUrl || eventData.infosheetUrl">
        <h2>{{ $t('eventRegistration.summary.terms') }}</h2>
        <base-input
            v-if="eventData.privacyUrl || eventData.termsUrl"
            :model-value="termsAndPrivacyAgreed"
            :rules="{ required: { allowFalse: false } }"
            :name="participantAndPrivacyTermsString">
            <BaseCheckbox
                v-model="termsAndPrivacyAgreed"
                multi-line>
                <span>
                    {{ $t('eventRegistration.summary.termsStart') }}
                    <template v-if="eventData.termsUrl">
                        <a
                            target="_blank"
                            :href="eventData.termsUrl">{{
                                $t('eventRegistration.summary.participationTermsOfOrganizer')
                            }}
                        </a>
                    </template>
                    <template v-if="eventData.privacyUrl">
                        {{ $t('eventRegistration.summary.termsAnd') }}
                        <a
                            target="_blank"
                            :href="eventData.privacyUrl">{{ $t('eventRegistration.summary.privacyAgreement') }}
                        </a>
                    </template>
                    {{ $t('eventRegistration.summary.termsEnd') }} *
                </span>
            </BaseCheckbox>
        </base-input>

        <base-input
            v-if="eventData.preContractualInfoUrl && eventData.infosheetUrl"
            :model-value="preContractualInformationAgreed"
            :rules="{ required: { allowFalse: false } }"
            :name="$t('eventRegistration.summary.preContractualInfo')">
            <BaseCheckbox
                v-model="preContractualInformationAgreed"
                multi-line>
                <span>
                    {{ $t('eventRegistration.summary.preContractualInfoStart') }}
                    <template v-if="eventData.preContractualInfoUrl">
                        {{ $t('eventRegistration.summary.preContractualInfoOfOrganizer1') }}
                        <a
                            href="#"
                            @click.prevent="showContractualInfo()">
                            {{ $t('eventRegistration.summary.preContractualInfoOfOrganizer2') }}
                        </a>
                    </template>
                    <template v-if="eventData.preContractualInfoUrl && eventData.infosheetUrl">
                        {{ $t('eventRegistration.summary.preContractualInfoAnd') }}
                    </template>
                    <template v-if="eventData.infosheetUrl">
                        {{ $t('eventRegistration.summary.moreInformationAboutYourRightsPart1') }}
                        <a
                            target="_blank"
                            :href="eventData.infosheetUrl">{{
                                $t('eventRegistration.summary.moreInformationAboutYourRightsPart2')
                            }}
                        </a>
                        {{ $t('eventRegistration.summary.moreInformationAboutYourRightsPart3') }}
                    </template>
                    {{ $t('eventRegistration.summary.preContractualInfoEnd') }} <br>
                    {{ $t('eventRegistration.summary.packageTourInfo') }} *
                </span>
            </BaseCheckbox>
        </base-input>
        <small>{{ $t('eventRegistration.summary.asteriskExplanation') }}</small>
    </div>
</template>

<script>

import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import contractualInfoMixin from "@/mixins/registration/contractualInfoMixin";

export default {
    name: "Terms",
    mixins: [mainRegistrationMixin, contractualInfoMixin],
    computed: {
        participantAndPrivacyTermsString() {
            let string = ""
            if (this.eventData.termsUrl)
                string += this.$t('eventRegistration.summary.participantTerms')
            if (this.eventData.termsUrl && this.eventData.privacyUrl)
                string += " " + this.$t('eventRegistration.summary.and') + " "
            if (this.eventData.privacyUrl)
                string += this.$t('eventRegistration.summary.privacy')

            return string
        },
        termsAndPrivacyAgreed: {
            get: function () {
                return this.registrationData.termsAndPrivacyAgreed
            },
            set: function (value) {
                this.setRegistrationProp('termsAndPrivacyAgreed', value)
            }
        },
        preContractualInformationAgreed: {
            get: function () {
                return this.registrationData.preContractualInformationAgreed
            },
            set: function (value) {
                this.setRegistrationProp('preContractualInformationAgreed', value)
            }
        }
    },
    methods: {
        async showContractualInfo() {
            const ref = this.openNewLoadingWindow();
            try {
                const response = await this.$axios.post(this.eventData.preContractualInfoUrl,
                                                        this.registrationData,
                                                        {responseType: 'blob'}
                )
                ref.location.href = URL.createObjectURL(response.data);
            } catch (e) {

                ref.close()
            }
        }
    }
}
</script>

<style scoped>

</style>
